// extracted by mini-css-extract-plugin
export default {"logo-wrapper":"LogoContentWrapper__logo-wrapper__OVgcC","content-wrapper":"LogoContentWrapper__content-wrapper__lrGzK"};